
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAvatars = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  viewBox: "0 0 120 120",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M42.474 27.764c13.42 0 24.3 10.88 24.3 24.301 0 9.356-5.288 17.475-13.037 21.537a39.609 39.609 0 0 1 21.135 15.191 2.2 2.2 0 1 1-3.598 2.53 35.21 35.21 0 0 0-57.607.003 2.2 2.2 0 0 1-3.6-2.531A39.61 39.61 0 0 1 31.209 73.6c-7.748-4.062-13.036-12.18-13.036-21.536 0-13.42 10.88-24.301 24.302-24.301Zm0 4.4c-10.991 0-19.901 8.91-19.901 19.901 0 10.976 8.884 19.875 19.853 19.9h.092c10.97-.023 19.857-8.923 19.857-19.9 0-10.99-8.91-19.9-19.901-19.9Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M70.94 28.11a2.2 2.2 0 1 0 1.194 4.235l-.597-2.117-.597-2.118Zm23.784 9.157-1.673 1.428 1.673-1.428Zm4.907 9.992-2.153.45 2.153-.45ZM98.043 61.27l1.998.921-1.998-.92ZM77.634 72.136a2.2 2.2 0 1 0 .001 4.4v-4.4Zm-.001 0a2.2 2.2 0 0 0 .003 4.4l-.001-2.2-.002-2.2ZM106.95 91.76a2.2 2.2 0 1 0 3.601-2.528l-1.801 1.264-1.8 1.264ZM71.537 30.228l.597 2.117a20.275 20.275 0 0 1 20.917 6.35l1.673-1.428 1.673-1.429A24.675 24.675 0 0 0 70.94 28.11l.597 2.118Zm23.187 7.039-1.673 1.428a20.25 20.25 0 0 1 4.427 9.014l2.153-.45 2.154-.45a24.653 24.653 0 0 0-5.388-10.971l-1.673 1.429Zm4.907 9.992-2.153.45a20.262 20.262 0 0 1-1.433 12.64l1.998.921 1.998.921a24.664 24.664 0 0 0 1.744-15.382l-2.154.45ZM98.043 61.27l-1.998-.92a20.275 20.275 0 0 1-18.41 11.786v4.4a24.676 24.676 0 0 0 22.406-14.345l-1.998-.92ZM77.634 74.337l.002 2.2A35.786 35.786 0 0 1 106.95 91.76l1.8-1.264 1.801-1.264a40.185 40.185 0 0 0-32.918-17.095l.002 2.2Z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"44\" height=\"44\" viewBox=\"0 0 120 120\" fill=\"none\">\r\n  <path d=\"M42.4739 27.7637C55.8949 27.764 66.7747 38.6444 66.7747 52.0654C66.7746 61.4214 61.4861 69.5404 53.7366 73.6016C62.1885 76.1097 69.6764 81.4034 74.8723 88.793C75.5712 89.7869 75.332 91.1585 74.3381 91.8574C73.3442 92.5562 71.9725 92.3171 71.2737 91.3232C64.68 81.9459 53.9335 76.3659 42.47 76.3662C31.0064 76.3667 20.2602 81.9481 13.6672 91.3262C12.9684 92.3199 11.5957 92.5591 10.6018 91.8604C9.60816 91.1615 9.36901 89.7888 10.0676 88.7949C15.2641 81.4035 22.7542 76.1086 31.2083 73.6006C23.4596 69.5391 18.1722 61.4206 18.1721 52.0654C18.1721 38.6442 29.0526 27.7637 42.4739 27.7637ZM42.4739 32.1641C31.4827 32.1641 22.5725 41.0742 22.5725 52.0654C22.5726 63.0406 31.4568 71.9401 42.426 71.9658H42.5178C53.4885 71.9418 62.3751 63.0417 62.3752 52.0654C62.3752 41.0744 53.4648 32.1643 42.4739 32.1641Z\" fill=\"#000000\"/>\r\n  <path d=\"M70.9405 28.1103C69.771 28.4398 69.09 29.655 69.4196 30.8245C69.7491 31.994 70.9642 32.6749 72.1337 32.3454L71.5371 30.2279L70.9405 28.1103ZM94.7242 37.2666L93.0512 38.6951L94.7242 37.2666ZM99.6312 47.2592L97.4777 47.7094L99.6312 47.2592ZM98.0426 61.2702L100.041 62.1913V62.1913L98.0426 61.2702ZM77.6345 72.1357C76.4195 72.1358 75.4346 73.1209 75.4347 74.3359C75.4349 75.551 76.42 76.5358 77.635 76.5357L77.6347 74.3357L77.6345 72.1357ZM77.6329 72.1369C76.4179 72.1378 75.4336 73.1235 75.4345 74.3385C75.4354 75.5535 76.4211 76.5378 77.6361 76.5369L77.6345 74.3369L77.6329 72.1369ZM106.95 91.7601C107.648 92.7545 109.02 92.9947 110.014 92.2966C111.009 91.5984 111.249 90.2263 110.551 89.2319L108.75 90.496L106.95 91.7601ZM71.5371 30.2279L72.1337 32.3454C79.7479 30.2001 87.9144 32.6792 93.0512 38.6951L94.7242 37.2666L96.3973 35.838C90.1459 28.5165 80.207 25.4995 70.9405 28.1103L71.5371 30.2279ZM94.7242 37.2666L93.0512 38.6951C95.3054 41.3353 96.7951 44.4438 97.4777 47.7094L99.6312 47.2592L101.785 46.8091C100.954 42.8352 99.1402 39.0504 96.3973 35.838L94.7242 37.2666ZM99.6312 47.2592L97.4777 47.7094C98.351 51.8867 97.9033 56.3177 96.0447 60.3492L98.0426 61.2702L100.041 62.1913C102.303 57.2847 102.847 51.8906 101.785 46.8091L99.6312 47.2592ZM98.0426 61.2702L96.0447 60.3492C92.7328 67.5331 85.5451 72.1348 77.6345 72.1357L77.6347 74.3357L77.635 76.5357C87.2623 76.5346 96.0099 70.9342 100.041 62.1913L98.0426 61.2702ZM77.6345 74.3369L77.6361 76.5369C89.3049 76.5285 100.245 82.2099 106.95 91.7601L108.75 90.496L110.551 89.2319C103.022 78.5074 90.7365 72.1274 77.6329 72.1369L77.6345 74.3369Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/avatars.f7599539754191a21058719de448a8de.svg"),
        {
          React: SvgAvatars,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      